module.exports = __webpack_public_path__ + "img/musicaeduca-online.5a702c7b.png";